import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible((window.scrollY || 0) > 250);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className={`
        fixed bottom-7 right-7 z-[99999]
        h-14 w-14 rounded-full
        bg-gradient-to-br from-blue-600 to-violet-600
        shadow-[0_14px_40px_rgba(59,130,246,0.45)]
        flex items-center justify-center
        transition-all duration-300 hover:-translate-y-1
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"}
      `}
    >
      <ChevronUp
        className="h-6 w-6 text-white"
        strokeWidth={3}
      />
    </button>
  );
}